var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3923 16L31.2671 4.12515C31.73 3.67722 31.9943 3.06438 31.9999 2.41964C32.0055 1.77681 31.7525 1.15831 31.2971 0.702893C30.8417 0.247465 30.2232 -0.00556854 29.5804 9.30011e-05C28.9356 0.0057152 28.3228 0.269977 27.8749 0.73288L16 12.6077L4.12515 0.73288C3.18433 -0.176086 1.68685 -0.162987 0.762865 0.762867C-0.16299 1.68685 -0.176088 3.18433 0.732878 4.12515L12.6077 16L0.732878 27.8748C0.269955 28.3228 0.00570531 28.9356 9.17493e-05 29.5804C-0.00553093 30.2232 0.247482 30.8417 0.702891 31.2971C1.15832 31.7525 1.77681 32.0056 2.41963 31.9999C3.06438 31.9943 3.67722 31.73 4.12515 31.2671L16 19.3923L27.8749 31.2671C28.8157 32.1761 30.3132 32.163 31.2371 31.2371C32.163 30.3131 32.1761 28.8157 31.2671 27.8748L19.3923 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close-white.dd006014d62712d2f3bda1d76dc6b3c8.svg";
export { ForwardRef as ReactComponent };